module.exports = __webpack_public_path__ + "static/media/Rio_web_client_event_serviceServiceClientPb.8ef7f948.ts";


//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio-grpc-interfaces-web-client/dist/generated/webevent/Rio_web_client_event_serviceServiceClientPb.ts
// module id = 4140
// module chunks = 11